import { getApiBase } from '@/lib/apiBase';

export const PLATFORM_ACCESS_KEY = 'platformAccessToken';
export const PLATFORM_REFRESH_KEY = 'platformRefreshToken';

export type FeatureKey =
  | 'BODY_CHART'
  | 'TEETH_CHART'
  | 'CLINICAL_PATHWAY'
  | 'VIBER'
  | 'LOCATION_TRAVEL_TIME'
  | 'LOYALTY'
  | 'MARKETING'
  | 'WORKFLOWS'
  | 'EQUIPMENT';

export interface ResolvedTenantConfig {
  slug: string;
  name: string;
  brandName: string;
  logo: string;
  favicon: string;
  singular: string;
  plural: string;
  whom: string;
  whomPlural: string;
  clinicalPathway: boolean;
  staffType: 'employee' | 'dentist' | 'doctor';
  schema: string;
  cmsPrimaryColor: string;
  cmsSecondaryColor: string;
  modulePrimaryColor: string;
  allowedDomains: string[];
  flags: Record<FeatureKey, boolean>;
  features: {
    bodyFeature?: unknown;
    teethFeature?: unknown;
  };
  status: 'PROVISIONING' | 'ACTIVE' | 'FAILED' | 'SUSPENDED';
}

export function applyBrandColors(config: {
  cmsPrimaryColor?: string;
  cmsSecondaryColor?: string;
}) {
  if (typeof document === 'undefined') return;
  const primary = config.cmsPrimaryColor || '#588782';
  const secondary = config.cmsPrimaryColor || primary;
  const root = document.documentElement;
  root.style.setProperty('--primary-color', primary);
  root.style.setProperty('--secondary-color', secondary);
  document.body?.style.setProperty('--primary-color', primary);
  document.body?.style.setProperty('--secondary-color', secondary);
}

export function applyFavicon(href?: string) {
  if (typeof document === 'undefined' || !href) return;
  let link = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
}

export async function fetchTenantConfig(host: string): Promise<ResolvedTenantConfig | null> {
  const base = getApiBase(host);
  try {
    const response = await fetch(
      `${base}/platform/tenants/resolve?host=${encodeURIComponent(host)}`,
      { credentials: 'include' },
    );
    if (!response.ok) return null;
    const json = await response.json();
    return json.data as ResolvedTenantConfig;
  } catch {
    return null;
  }
}

export function toCmsConfig(resolved: ResolvedTenantConfig) {
  return {
    name: resolved.name,
    logo: resolved.logo,
    favicon: resolved.favicon,
    singular: resolved.singular,
    plural: resolved.plural,
    whom: resolved.whom,
    whomPlural: resolved.whomPlural,
    clinicalPathway: resolved.clinicalPathway,
    allowedDomains: resolved.allowedDomains,
    staffType: resolved.staffType,
    cmsPrimaryColor: resolved.cmsPrimaryColor,
    cmsSecondaryColor: resolved.cmsSecondaryColor,
    flags: resolved.flags,
    features: resolved.features,
  };
}
